import api from "./api";

const banners = `mocks${import.meta.env.VITE_BASE_PATH}banners.experiencia.json`
var jsonFinal = "" 
class BannerExperienciaService {
  async get() {
    if(!jsonFinal){
      const resp = await fetch(banners)
      jsonFinal = await resp.json()
    }
    return jsonFinal
  }
}

export default new BannerExperienciaService();
